import Swiper from "swiper/bundle";

export const setupSwiper = (id: string, options: any) => {
  const checkDOM = document.getElementById(id);
  if (checkDOM) {
    return new Swiper("#" + id, options);
  }
};
